jQuery(document).ready(function ($) {

    var module_name = 'table';

    $('.' + module_name.replace(/_/g, '-') + '-module').each(function (index) {    

    $('.front-page-table').dataTable({
        "order": [[ 5, "png" ], [ 6, "odds" ]],
        paging: false,
        searching: false,
        info: false,
    });

    });

    // $( ".tab" ).each(function( index ) {
    //     $(this).find(".ranking").find("td").first().prepend("<span class='ranked'>"+ "#1 " +'</span>');
    //  });
     
    //  $( ".tab-fantasy" ).each(function( index ) {
    //     if(!$(this).find('span').hasClass('ranked')){
    //         $(this).find(".ranking").find("td").first().prepend("<span class='ranked'>"+ "#1 " +'</span>');
    //     }
    // });
});

